"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableDates = exports.RepeatIntervalEnum = exports.AvailabilityEnum = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
var AvailabilityEnum;
(function (AvailabilityEnum) {
    AvailabilityEnum["BUSY"] = "busy";
    AvailabilityEnum["AVAILABLE"] = "available";
})(AvailabilityEnum = exports.AvailabilityEnum || (exports.AvailabilityEnum = {}));
var RepeatIntervalEnum;
(function (RepeatIntervalEnum) {
    RepeatIntervalEnum["WEEKDAY"] = "weekday";
    RepeatIntervalEnum["WEEKEND"] = "weekend";
    RepeatIntervalEnum["DAY"] = "day";
})(RepeatIntervalEnum = exports.RepeatIntervalEnum || (exports.RepeatIntervalEnum = {}));
const PROPOSAL_DAY_LIMIT = 45;
const DAY_START_HOUR = 8;
const DAY_END_HOUR = 21;
const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
function configSlotApplicable(slot, day) {
    if (slot.repeatInterval === 'weekday' && day.day() > 0 && day.day() < 6) {
        return true;
    }
    else if (slot.repeatInterval === 'weekend' && (day.day() === 0 || day.day() === 6)) {
        return true;
    }
    else if (slot.repeatInterval === WEEKDAYS[day.day()]) {
        return true;
    }
    return false;
}
function slotContains(dayScheduleSlot, availabilitySlot) {
    if (dayScheduleSlot.startAt <= availabilitySlot.startTime && dayScheduleSlot.endAt >= availabilitySlot.endTime) {
        return true;
    }
    else {
        return false;
    }
}
function slotOverlaps(dayScheduleSlot, availabilitySlot) {
    if ((dayScheduleSlot.startAt >= availabilitySlot.startTime && dayScheduleSlot.startAt < availabilitySlot.endTime) ||
        (dayScheduleSlot.endAt > availabilitySlot.startTime && dayScheduleSlot.endAt <= availabilitySlot.endTime) ||
        (dayScheduleSlot.startAt <= availabilitySlot.startTime && dayScheduleSlot.endAt >= availabilitySlot.endTime)) {
        return true;
    }
    else {
        return false;
    }
}
function mergeAdjacentSlots(slots) {
    const sortedSlots = slots.sort((s1, s2) => {
        return s1.startAt - s2.startAt;
    });
    const mergedSlots = [];
    for (let i = 0; i < sortedSlots.length; i++) {
        const slot = sortedSlots[i];
        if (slot.merged) {
            continue;
        }
        if (slot.type !== AvailabilityEnum.AVAILABLE) {
            mergedSlots.push(slot);
            continue;
        }
        for (let j = i + 1; j < sortedSlots.length; j++) {
            const slot2 = sortedSlots[j];
            if (slot2.type === AvailabilityEnum.AVAILABLE && slot2.startAt === slot.endAt) {
                slot.endAt = slot2.endAt;
                slot2.merged = true;
            }
        }
        mergedSlots.push(slot);
    }
    return mergedSlots;
}
function getAvailableDates(schedule = [], pros = [], durationHours, dayLimit = PROPOSAL_DAY_LIMIT, timezone = 'Europe/Vilnius') {
    const now = (0, dayjs_1.default)().tz(timezone);
    // console.log(dayjs().unix(), dayjs().tz(timezone).unix());
    const today = now.startOf('day');
    // console.log(now.format('YYYY-MM-DD HH:mm'), today.format('YYYY-MM-DD HH:mm'));
    const dayAvailability = [];
    for (let i = 0; i < dayLimit; i++) {
        const day = today.add(i, 'day');
        const dayAvailabilitySlots = [];
        for (let j = DAY_START_HOUR; j < DAY_END_HOUR - durationHours; j++) {
            // TODO: need to account that today times are not available in the past
            // TODO: need to add half hour intervals
            const hours = parseInt(durationHours + '');
            const minutes = (durationHours - hours) * 60;
            const slot = {
                startTime: +day.minute(0).hour(j),
                endTime: +day.minute(minutes).hour(j + hours),
                prosAvailable: [],
            };
            dayAvailabilitySlots.push(slot);
        }
        dayAvailability.push({
            day: +day,
            slots: dayAvailabilitySlots,
        });
    }
    const prosSchedule = {};
    pros.forEach((pro) => {
        prosSchedule[pro.id] = [];
    });
    schedule.forEach((scheduleSlot) => {
        prosSchedule[scheduleSlot.workerId].push(scheduleSlot);
    });
    for (let i = 0; i < dayLimit; i++) {
        const day = today.add(i, 'day');
        pros.forEach((pro) => {
            const proDaySchedule = [];
            pro.availabilityConfig.forEach((configSlot) => {
                if (configSlotApplicable(configSlot, day)) {
                    const slot = {
                        type: configSlot.type,
                        startAt: +day.hour(configSlot.startTime),
                        endAt: +day.hour(configSlot.endTime),
                        workerId: pro.id,
                    };
                    proDaySchedule.push(slot);
                }
            });
            prosSchedule[pro.id].forEach((scheduleSlot) => {
                // do not check due to performance issues
                // if (
                //   dayjs.tz(scheduleSlot.startAt, timezone).isSame(day, 'day') ||
                //   dayjs.tz(scheduleSlot.endAt, timezone).isSame(day, 'day')
                // ) {
                proDaySchedule.push(scheduleSlot);
                // }
            });
            const proDayScheduleMerged = mergeAdjacentSlots(proDaySchedule);
            // console.log('PRE MERGE', proDaySchedule, 'POST MERGE', proDayScheduleMerged);
            dayAvailability[i].slots.forEach((availabilitySlot) => {
                let proAvailable = false;
                for (let j = 0; j < proDayScheduleMerged.length; j++) {
                    const dayScheduleSlot = proDayScheduleMerged[j];
                    if (dayScheduleSlot.type === AvailabilityEnum.AVAILABLE && slotContains(dayScheduleSlot, availabilitySlot)) {
                        proAvailable = true;
                    }
                    else if (dayScheduleSlot.type === AvailabilityEnum.BUSY &&
                        slotOverlaps(dayScheduleSlot, availabilitySlot)) {
                        proAvailable = false;
                        return;
                    }
                }
                if (proAvailable) {
                    availabilitySlot.prosAvailable.push(pro.id);
                }
            });
        });
    }
    const filteredDayAvailability = [];
    dayAvailability.forEach((value) => {
        value.slots.forEach((slot) => {
            if (slot.prosAvailable.length > 0) {
                filteredDayAvailability.push(slot);
            }
        });
    });
    return filteredDayAvailability;
}
exports.getAvailableDates = getAvailableDates;
//# sourceMappingURL=availability.js.map